import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import Navigation from "./components/Navigation/Navigation";
import Homepage from "./components/Homepage/Homepage";
import Channels from "./components/Channels/Channels";
import SingleChannel from "./components/SingleChannel/SingleChannel";
import VideoPage from "./components/VideoPage/VideoPage";
import UploadVideo from "./components/UploadVideo/UploadVideo";
import History from "./components/History/History";
import Upload from "./components/Upload/Upload";
import Blog from "./components/Blog/Blog";
import BlogDetails from "./components/Blog/BlogDetails";
import Blank from "./components/Blank/Blank";
import FourZeroFour from "./components/FourZeroFour/FourZeroFour";
import Subscriptions from "./components/Subscriptions/Subscriptions";
import Auth from "./components/Auth/Auth";
import Settings from "./components/Settings/Settings";
import Account from "./components/Account/Account";
import Videos from "./components/VideoPage/Videos";
import CreateChannel from "./components/Channels/CreateChannel";
import { CustomScrollToTop } from "./components/Atomics/ScrollToTop/ScrollToTop";
import PlaylistVideos from "./components/SingleChannel/PlaylistVideos";
import ChooseAdmin from "./components/Channels/ChooseAdmin";
import Toaster from "./components/Atomics/Toaster";
import ChannelEdit from "./components/Channels/ChannelEdit";
import VideoEdit from "./components/VideoPage/VideoEdit";
import Sidebar from "./components/Sidebar/Sidebar";
import ReportProblem from "./components/ReportProblem/ReportProblem";
import Tutorial from "./components/Tutorial";
import ChangePassword from "./components/ChangePassword";
import Statistics from "./components/Statistics";
import UserManagement from "./components/userManagement";
import AuthGuard from "./components/Auth/AuthGaurd";
import RoleGuard from "./components/Auth/RoleGaurd";
import CommentStatistics from "./components/CommentStatistics";
import InteractionStatistics from "./components/InteractionStatistics";
import BoxManagement from "./components/BoxManagement";
import ViewStatistics from "./components/ViewStatistics";
import CreateCampaign from "./components/Channels/CreateCampaign";
import CampaignResult from "./components/CampaignResult";
import CreateCampaignResult from "./components/Channels/CreateCampaignResult";
import Exhibition from "./components/Exhibition/Exhibition";
import ExhibitionAdmin from "./components/Exhibition/Admin";
import PermissionGuard from "./components/Auth/PermissionGaurd";
import { ExhibitionContextProvider } from "./context/exhibition";
import { BlogContextProvider } from "./context/blog";
import { SelectedChannelsProvider } from "./context/selectedChannels";
import { SelectedVideosProvider } from "./context/selectedVideos";
import { MessagesContextProvider } from "./context/messages";
import { TagsContextProvider } from "./context/tag";
import { CategoryContextProvider } from "./context/categories";
import { ChannelContextProvider } from "./context/channels";
import { SidebarContextProvider } from "./context/sidebar";
import CommentManagement from "./components/CommentManagement";
import Broadcast from "./components/Broadcast/broadcast";

function App() {
  return (
    <SidebarContextProvider>
      <Router>
        <Switch>
          <Route path="/auth" component={Auth} />
          <Route path="/">
            <Content />
          </Route>
          <Route path="*" component={FourZeroFour} />
        </Switch>

        <Toaster />
      </Router>
    </SidebarContextProvider>
  );
}

function Content() {
  return (
    <>
      <div className="homepage-wrapper">
        <MessagesContextProvider>
          <Navigation />
        </MessagesContextProvider>
        <div id="wrapper">
          <ExhibitionContextProvider>
            <TagsContextProvider>
              <CategoryContextProvider>
                <Sidebar />
              </CategoryContextProvider>
            </TagsContextProvider>
          </ExhibitionContextProvider>

          <Switch>
            <Route exact path="/">
              <SelectedVideosProvider>
                <SelectedChannelsProvider>
                  <Homepage />
                </SelectedChannelsProvider>
              </SelectedVideosProvider>
            </Route>

            <Route exact path="/channels">
              <SelectedChannelsProvider>
                <ChannelContextProvider>
                  <Channels mine={false} />
                </ChannelContextProvider>
              </SelectedChannelsProvider>
            </Route>

            <Route exact path="/campaigns">
              <SelectedChannelsProvider>
                <ChannelContextProvider>
                  <Channels mine={false} />
                </ChannelContextProvider>
              </SelectedChannelsProvider>
            </Route>

            <Route exact path="/single-channel/:id">
              <SelectedVideosProvider>
                <SingleChannel />
              </SelectedVideosProvider>
            </Route>

            <Route path="/video-page/:id">
              <VideoPage />
            </Route>

            <Route path="/special-video-page/:id">
              <VideoPage />
            </Route>

            <Route exact path="/history">
              <AuthGuard>
                <History />
              </AuthGuard>
            </Route>

            <Route exact path="/report-problem">
              <AuthGuard>
                <ReportProblem />
              </AuthGuard>
            </Route>

            <Route exact path="/tutorial">
              <Tutorial />
            </Route>
            {/* <Route exact path="/categories">
              <Categories mine={false} />
            </Route>
            <Route exact path="/myCategories">
              <Categories mine={true} />
            </Route> */}
            <Route exact path="/upload/:id/">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <Upload />
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/blog">
              <BlogContextProvider>
                <Blog />
              </BlogContextProvider>
            </Route>

            <Route exact path="/exhibition/:id">
              <ExhibitionContextProvider>
                <Exhibition />
              </ExhibitionContextProvider>
            </Route>

            <Route exact path="/exhibition-admin">
              <AuthGuard>
                <RoleGuard allowedRoles={["is_superuser", "is_supervisor"]}>
                  <ExhibitionContextProvider>
                    <ExhibitionAdmin />
                  </ExhibitionContextProvider>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/blog-details/:id">
              <BlogContextProvider>
                <BlogDetails />
              </BlogContextProvider>
            </Route>

            <Route exact path="/blank">
              <AuthGuard>
                <MessagesContextProvider>
                  <Blank />
                </MessagesContextProvider>
              </AuthGuard>
            </Route>

            {/* <Route exact path="/contact">
              <Contact />
            </Route> */}
            <Route exact path="/subscriptions">
              <AuthGuard>
                <Subscriptions />
              </AuthGuard>
            </Route>

            <Route exact path="/savedVideos">
              <AuthGuard>
                <SelectedVideosProvider>
                  <Videos mine={false} saved={true} />
                </SelectedVideosProvider>
              </AuthGuard>
            </Route>

            <Route exact path="/settings">
              <AuthGuard>
                <Settings />
              </AuthGuard>
            </Route>

            <Route exact path="/statistics">
              <AuthGuard>
                <RoleGuard allowedRoles={["is_superuser", "is_supervisor"]}>
                  <SelectedVideosProvider>
                    <TagsContextProvider>
                      <CategoryContextProvider>
                        <Statistics />
                      </CategoryContextProvider>
                    </TagsContextProvider>
                  </SelectedVideosProvider>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/changePassword">
              <AuthGuard>
                <ChangePassword />
              </AuthGuard>
            </Route>

            <Route exact path="/account">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <SelectedChannelsProvider>
                    <ChannelContextProvider>
                      <Account />
                    </ChannelContextProvider>
                  </SelectedChannelsProvider>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/videos/:id">
              <SelectedVideosProvider>
                <Videos mine={false} />
              </SelectedVideosProvider>
            </Route>

            <Route exact path="/videos">
              <SelectedVideosProvider>
                <Videos mine={false} allVideos={true} />
              </SelectedVideosProvider>
            </Route>

            <Route exact path="/campaign-result/:id">
              <CampaignResult />
            </Route>

            <Route exact path="/tag-videos/:id">
              <SelectedVideosProvider>
                <Videos mine={false} tag={true} />
              </SelectedVideosProvider>
            </Route>

            <Route exact path="/sub-category-videos/:id">
              <SelectedVideosProvider>
                <Videos mine={false} subCategory={true} />
              </SelectedVideosProvider>
            </Route>

            <Route exact path="/liked-videos">
              <SelectedVideosProvider>
                <Videos mine={false} liked={true} />
              </SelectedVideosProvider>
            </Route>

            <Route exact path="/campaign-videos">
              <AuthGuard>
                <SelectedVideosProvider>
                  <Videos mine={true} />
                </SelectedVideosProvider>
              </AuthGuard>
            </Route>

            <Route exact path="/popular-videos">
              <SelectedVideosProvider>
                <Videos mine={false} popular={true} />
              </SelectedVideosProvider>
            </Route>

            <Route exact path="/myVideos">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <SelectedVideosProvider>
                    <Videos mine={true} />
                  </SelectedVideosProvider>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/myVideos/:id">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <SelectedVideosProvider>
                    <Videos mine={true} />
                  </SelectedVideosProvider>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/allMyVideos/:id">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <SelectedVideosProvider>
                    <Videos mine={true} owner={true} />
                  </SelectedVideosProvider>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/set-campaign-result/:id">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <PermissionGuard allowedPermissions={["campaign_result"]}>
                    <CreateCampaignResult />
                  </PermissionGuard>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/comment-statistics">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <CommentStatistics />
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/box-management">
              <AuthGuard>
                <RoleGuard allowedRoles={["is_supervisor", "is_superuser"]}>
                  <PermissionGuard allowedPermissions={["box_managment"]}>
                    <SelectedVideosProvider>
                      <SelectedChannelsProvider>
                        <TagsContextProvider>
                          <CategoryContextProvider>
                            <BoxManagement />
                          </CategoryContextProvider>
                        </TagsContextProvider>
                      </SelectedChannelsProvider>
                    </SelectedVideosProvider>
                  </PermissionGuard>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/broadcast">
              <AuthGuard>
                <RoleGuard allowedRoles={["is_supervisor", "is_superuser"]}>
                  <PermissionGuard allowedPermissions={["public_notification"]}>
                    <Broadcast />
                  </PermissionGuard>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/interaction-statistics">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <InteractionStatistics />
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/view-statistics">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <ViewStatistics />
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/create-channel">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <CreateChannel />
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/create-campaign">
              <AuthGuard>
                <RoleGuard allowedRoles={["is_supervisor", "is_superuser"]}>
                  <PermissionGuard allowedPermissions={["campaign"]}>
                    <CreateCampaign />
                  </PermissionGuard>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/playlist/:id">
              <SelectedVideosProvider>
                <PlaylistVideos />
              </SelectedVideosProvider>
            </Route>

            <Route exact path="/channel-edit/:id/">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <ChannelEdit />
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/comments-management/:id/">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <CommentManagement />
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/video-edit/:id/">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <TagsContextProvider>
                    <CategoryContextProvider>
                      <VideoEdit />
                    </CategoryContextProvider>
                  </TagsContextProvider>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/choose-admin/:id/">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <ChooseAdmin />
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/search">
              <SelectedVideosProvider>
                <Videos search={true} />
              </SelectedVideosProvider>
            </Route>

            <Route exact path="/upload-video/:id/">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <TagsContextProvider>
                    <CategoryContextProvider>
                      <UploadVideo />
                    </CategoryContextProvider>
                  </TagsContextProvider>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/user-management">
              <AuthGuard>
                <RoleGuard allowedRoles={["is_supervisor", "is_superuser"]}>
                  <PermissionGuard allowedPermissions={["user_list"]}>
                    <UserManagement />
                  </PermissionGuard>
                </RoleGuard>
              </AuthGuard>
            </Route>

            <Route exact path="/myChannels">
              <AuthGuard>
                <RoleGuard
                  allowedRoles={["is_supervisor", "is_superuser", "staff"]}
                >
                  <SelectedChannelsProvider>
                    <ChannelContextProvider>
                      <Channels mine={true} />
                    </ChannelContextProvider>
                  </SelectedChannelsProvider>
                </RoleGuard>
              </AuthGuard>
            </Route>
            <Route path="*" component={FourZeroFour} />
          </Switch>
        </div>
        <ScrollToTop
          smooth
          component={<CustomScrollToTop />}
          className="scroll-to-top outline-0"
          color="white"
        />

        <Toaster />
      </div>
    </>
  );
}

export default App;
